import { SeeqNames } from 'generated-seeqnames/app.constants.seeqnames';

const packageName = SeeqNames.MlService.Clustering.Connection.UdfPackage;
const udfName = SeeqNames.MlService.Clustering.Connection.UdfName;
export const UDF_NAME = `${packageName}_${udfName}`;

export const CLUSTER_CENTERS_KEY = 'cluster_centers';
export const CAPSULE_PROPERTY_NAME = 'Cluster';
export const OUTPUT_METADATA_LABEL_MODEL_INPUT_PROPERTIES = 'model_input_properties';
export const SORT_AS_STRING = true;
export const DEFAULT_NUM_CLUSTERS = 3;
export const MAX_INPUT_SIGNALS = 50;

export const INPUT_NAMES = {
  numClustersInput: 'numClustersInput',
  startTimeInput: 'startTimeInput',
  endTimeInput: 'endTimeInput',
  signalInput: 'signalInput',
  restrictOutputToConditionInput: 'restrictOutputToConditionInput',
  trainWithinConditionInput: 'trainWithinConditionInput',
};

export const OUTPUT_TRANSLATION_KEYS: Record<string, Record<string, string>> = {
  clustersOutput: {
    label: 'INVESTIGATE_TOOLS.CLUSTERING_V2.OUTPUTS.CLUSTERING_CONDITION',
    icon: 'fc fc-capsule-set',
  },
  initOutput: {
    label: 'INVESTIGATE_TOOLS.CLUSTERING_V2.OUTPUTS.INIT',
    icon: 'fc fc-scalar',
  },
  inertiaOutput: {
    label: 'INVESTIGATE_TOOLS.CLUSTERING_V2.OUTPUTS.INERTIA',
    icon: 'fc fc-scalar',
  },
  kmeansAlgorithmOutput: {
    label: 'INVESTIGATE_TOOLS.CLUSTERING_V2.OUTPUTS.K_MEANS_ALGORITHM',
    icon: 'fc fc-scalar',
  },
  clusterCentersOutput: {
    label: 'INVESTIGATE_TOOLS.CLUSTERING_V2.OUTPUTS.CLUSTER_CENTERS',
    icon: 'fc fc-scalar',
  },
  modelInputPropertiesOutput: {
    label: 'INVESTIGATE_TOOLS.CLUSTERING_V2.OUTPUTS.MODEL_INPUT_PROPERTIES',
    icon: 'fc fc-scalar',
  },
  trainingWindowConditionOutput: {
    label: 'INVESTIGATE_TOOLS.CLUSTERING_V2.OUTPUTS.TRAINING_WINDOW_CONDITION',
    icon: 'fc fc-capsule-set',
  },
};

export const DEFAULT_OUTPUTS: string[] = ['clustersOutput'];

export const MODEL_NAME = SeeqNames.ModelNames.Clustering;
